"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _MSN6U3HDcjs = require('../__chunks/MSN6U3HD.cjs');


var _W5HIR4GYcjs = require('../__chunks/W5HIR4GY.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/checkbox/checkbox-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function CheckboxProvider(props = {}) {
  const store = _MSN6U3HDcjs.useCheckboxStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _W5HIR4GYcjs.CheckboxContextProvider, { value: store, children: props.children });
}


exports.CheckboxProvider = CheckboxProvider;
